import { Star } from "lucide-react";

export const Stars = ({ value = 0, size = "w-3.5 h-3.5", onChange, testid = "stars" }) => (
  <div data-testid={testid} className="flex items-center gap-0.5">
    {[1, 2, 3, 4, 5].map((n) => {
      const filled = n <= Math.round(value);
      const cls = `${size} ${filled ? "fill-[#FF9500] text-[#FF9500]" : "text-neutral-600"} ${onChange ? "cursor-pointer hover:scale-110 transition-transform" : ""}`;
      return onChange ? (
        <button key={n} type="button" data-testid={`${testid}-${n}`} onClick={() => onChange(n)} aria-label={`${n} stars`}><Star className={cls} /></button>
      ) : <Star key={n} className={cls} />;
    })}
  </div>
);
